// extracted by mini-css-extract-plugin
module.exports = {"root":"PlanBadge_root__jDjQI","premium":"PlanBadge_premium__3v2Lq","enterprise":"PlanBadge_enterprise__20DKQ"};